import { render } from "./AttributeTableWin.vue?vue&type=template&id=37906c94&scoped=true"
import script from "./AttributeTableWin.vue?vue&type=script&lang=js"
export * from "./AttributeTableWin.vue?vue&type=script&lang=js"

import "./AttributeTableWin.vue?vue&type=style&index=0&id=37906c94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37906c94"]])

export default __exports__